module.exports = (parcelRequire.load("eJJXG")).then(() => parcelRequire('77u3g'));